import type { EnrichedStakeholdersReport } from "../types/stakeholder-v2.types";

export const STAKEHOLDERS_V2_INSUFFICIENT_DATA_EVENT = 'stakeholders_report_v2_insufficient_data';

export interface StakeholdersReportEvent {
    companyId: number | string;
    companyName?: string;
    departmentId?: number;
    departmentName?: string;
    stage?: string;
    progress?: number;
    error?: string;
    reason?: string;
    reasonCode?: string;
    status?: string;
    reportId?: number;
    updatedAt?: Date | string;
    totalContactsReviewed?: number;
}

export const isInsufficientDataReportEvent = (data: Pick<StakeholdersReportEvent, 'status'>): boolean => {
    return data.status === 'insufficient_data';
};

export const buildInsufficientDataReport = (data: StakeholdersReportEvent): EnrichedStakeholdersReport => {
    const timestamp = data.updatedAt ? new Date(data.updatedAt) : new Date();

    return {
        topContacts: [],
        otherContacts: [],
        summary: {
            totalContactsReviewed: data.totalContactsReviewed ?? 0,
            topChampions: 0,
            topSponsors: 0,
            topDecisionMakers: 0,
            otherStakeholders: 0,
            engagementStrategy: '',
        },
        metadata: {
            status: 'insufficient_data',
            products: [],
            buyingPersona: [],
            targetDepartmentIds: [],
            createdAt: timestamp,
            updatedAt: timestamp,
            otherContactsTotal: 0,
        },
    };
};
